"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedcash = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedcash` : '') + (description ? ` desc-brandedcash` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedcash"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedcash"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M58 29C58 45.0136 45.0162 58.0027 29.0026 58.0027C12.9891 58.0027 0 45.0188 0 29C0 12.9813 12.9838 0.00268555 28.9974 0.00268555C45.0109 0.00268555 57.9948 12.9865 57.9948 29H58Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9989 0.00260784V58C21.5 58 13.9716 55.1059 8.50003 49.5C2.96148 43.82 0.0659991 36.3982 0.0501147 29C0.0337947 21.3989 3.05158 13.7228 8.9431 8.08623C14.7322 2.55368 21.5429 -0.096936 28.9989 0.00260784Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35 17H27.4C26.233 17 25.1139 17.4636 24.2887 18.2887C23.4636 19.1139 23 20.233 23 21.4C23 28 35 28 35 34.6C35 35.767 34.5364 36.8861 33.7113 37.7113C32.8861 38.5364 31.767 39 30.6 39H23",
    stroke: "#FFF5EB",
    strokeWidth: "7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29 16V12",
    stroke: "#FFF5EB",
    strokeWidth: "7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29 39V45",
    stroke: "#FFF5EB",
    strokeWidth: "7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var _default = exports.default = brandedcash;